import React from "react";
import { Modal, Button } from "react-bootstrap";

export const TemplateConfirmModal = ({ show, templateName, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Apply Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Applying the <strong>{templateName}</strong> template will overwrite
                    the current group's trade settings including risk size, algorithms, and
                    trading limits. None of these templates turn trading on for you. To begin trading,
                    you need to turn trading on and select accounts to trade on.
                </p>
                <p>
                    After applying the template, you will still need to review the settings,
                    change anything that is not right for your situation, and click Submit to save these changes.
                </p>
                <p>
                    <strong>IMPORTANT:</strong> You must review the settings applied by this template and make sure they
                    are right for your accounts and your situation. These templates are not tailored to your
                    financial situation, risk tolerance, or investment objectives. They are meant to help get you
                    up and running faster, but are not recommendations and should not be construed
                    as trading advice. Past performance is not indicative of future results. Trading futures
                    involves substantial risk of loss and is not suitable for all investors.
                </p>
                <p>
                    By clicking "I Understand", you acknowledge and agree to these statements and
                    to be bound by the <a href="/legal/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    I Understand
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
